import {StringUnion} from 'Core/models/EmptyString';
import {useDispatch} from 'react-redux';
import DateUtility from 'Shared/utilities/DateUtility';
import * as CIActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import * as AActions from 'ApplicationEntry/ducks/ProductsRiders/accident';
import * as CActions from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import * as SActions from 'ApplicationEntry/ducks/ProductsRiders/shop';
import {changeMonthly, changeWeekly} from 'ApplicationEntry/ducks/premium';
import {PackageModel} from 'ApplicationEntry/models/ProductsRiders/PackageModel';
import {isLoaded} from 'ApplicationEntry/models/ProductsRiders/PackageModel';

const useBuildPremiumParameterAutoFill = () => {
  const dispatch = useDispatch();
  const getAgeBandParameterGVCIP4 = (
    productType: StringUnion,
    billingModeValue: StringUnion,
    planType: StringUnion,
    insuredSC: StringUnion,
    spouseSC: StringUnion
  ): string => {
    let premiumAgeBandParameter = '';
    if (
      billingModeValue.value.toUpperCase() === 'WEEKLY' ||
      billingModeValue.value.toUpperCase() === 'BI-WEEKLY' ||
      billingModeValue.value.toUpperCase() === '28DAY'
    ) {
      if (insuredSC.value.toUpperCase() === 'NON SMOKER') {
        return (premiumAgeBandParameter = 'nonTob_WeeklyPremium_');
      } else if (insuredSC.value.toUpperCase() === 'SMOKER') {
        return (premiumAgeBandParameter = 'tob_WeeklyPremium_');
      }
    } else {
      if (insuredSC.value.toUpperCase() === 'NON SMOKER') {
        return (premiumAgeBandParameter = 'nonTob_MonthlyPremium_');
      } else if (insuredSC.value.toUpperCase() === 'SMOKER') {
        return (premiumAgeBandParameter = 'tob_MonthlyPremium_');
      }
    }
    return premiumAgeBandParameter;
  };
  const buildPremiumParameter = (
    productType: StringUnion,
    billingModeValue: StringUnion,
    planType: StringUnion,
    insuredSC: StringUnion,
    spouseSC: StringUnion
  ): string => {
    let premiumParameter = '';
    if (
      productType.value === 'GVCIFX' ||
      productType.value === 'GVCIP1' ||
      productType.value === 'GVCIP2' ||
      productType.value === 'GVCIP4'
    ) {
      if (
        billingModeValue.value.toUpperCase() === 'WEEKLY' ||
        billingModeValue.value.toUpperCase() === 'BI-WEEKLY' ||
        billingModeValue.value.toUpperCase() === '28DAY'
      ) {
        if (planType.value.toUpperCase() === 'IND' && insuredSC.value.toUpperCase() === 'NON SMOKER') {
          premiumParameter = 'ind_NonTob_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'IND' && insuredSC.value.toUpperCase() === 'SMOKER') {
          premiumParameter = 'ind_Tob_WeeklyPremium_';
        }
        if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'NON SMOKER' || spouseSC.value === '')
        ) {
          premiumParameter = 'fam_NonTob_WeeklyPremium_';
        } else if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' || spouseSC.value.toUpperCase() === 'NON SMOKER')
        ) {
          premiumParameter = 'fam_Tob_WeeklyPremium_';
        } else if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' ||
            spouseSC.value.toUpperCase() === 'NON SMOKER' ||
            spouseSC.value === '')
        ) {
          premiumParameter = 'fam_Tob_WeeklyPremium_';
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'NON SMOKER' || spouseSC.value === '')
        ) {
          premiumParameter = 'sp_NonTob_WeeklyPremium_';
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' || spouseSC.value.toUpperCase() === 'NON SMOKER')
        ) {
          premiumParameter = 'sp_Tob_WeeklyPremium_';
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' ||
            spouseSC.value.toUpperCase() === 'NON SMOKER' ||
            spouseSC.value === '')
        ) {
          premiumParameter = 'sp_Tob_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'INDCH' && insuredSC.value.toUpperCase() === 'NON SMOKER') {
          premiumParameter = 'chd_NonTob_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'INDCH' && insuredSC.value.toUpperCase() === 'SMOKER') {
          premiumParameter = 'chd_Tob_WeeklyPremium_';
        }
      } else {
        if (planType.value.toUpperCase() === 'IND' && insuredSC.value.toUpperCase() === 'NON SMOKER') {
          premiumParameter = 'ind_NonTob_MonthlyPremium_';
        } else if (planType.value.toUpperCase() === 'IND' && insuredSC.value.toUpperCase() === 'SMOKER') {
          premiumParameter = 'ind_Tob_MonthlyPremium_';
        } else if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'NON SMOKER' || spouseSC.value === '')
        ) {
          return (premiumParameter = 'fam_NonTob_MonthlyPremium_');
        } else if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' || spouseSC.value.toUpperCase() === 'NON SMOKER')
        ) {
          premiumParameter = 'fam_Tob_MonthlyPremium_';
        } else if (
          planType.value.toUpperCase() === 'FAMILY' &&
          insuredSC.value.toUpperCase() === 'SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' ||
            spouseSC.value.toUpperCase() === 'NON SMOKER' ||
            spouseSC.value === '')
        ) {
          premiumParameter = 'fam_Tob_MonthlyPremium_';
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'NON SMOKER' || spouseSC.value === '')
        ) {
          return (premiumParameter = 'sp_NonTob_MonthlyPremium_');
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'NON SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' || spouseSC.value.toUpperCase() === 'NON SMOKER')
        ) {
          premiumParameter = 'sp_Tob_MonthlyPremium_';
        } else if (
          planType.value.toUpperCase() === 'INDSPS' &&
          insuredSC.value.toUpperCase() === 'SMOKER' &&
          (spouseSC.value.toUpperCase() === 'SMOKER' ||
            spouseSC.value.toUpperCase() === 'NON SMOKER' ||
            spouseSC.value === '')
        ) {
          premiumParameter = 'sp_Tob_MonthlyPremium_';
        } else if (planType.value.toUpperCase() === 'INDCH' && insuredSC.value.toUpperCase() === 'NON SMOKER') {
          return (premiumParameter = 'chd_NonTob_MonthlyPremium_');
        } else if (planType.value.toUpperCase() === 'INDCH' && insuredSC.value.toUpperCase() === 'SMOKER') {
          premiumParameter = 'chd_Tob_MonthlyPremium_';
        }
      }
    }

    if (productType.value === 'GVCP3' || productType.value === 'GVCP2') {
      if (
        billingModeValue.value.toUpperCase() === 'WEEKLY' ||
        billingModeValue.value.toUpperCase() === 'BI-WEEKLY' ||
        billingModeValue.value.toUpperCase() === '28DAY'
      ) {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_WeeklyBasicPremium';
        } else if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_WeeklyBasicPremium';
        } else if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'chd_WeeklyBasicPremium';
        } else if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'sp_WeeklyBasicPremium';
        }
      } else if (
        billingModeValue.value.toUpperCase() === 'MONTHLY' ||
        billingModeValue.value.toUpperCase() === 'SEMIMONTHLY' ||
        billingModeValue.value.toUpperCase() === 'NINTHLY' ||
        billingModeValue.value.toUpperCase() === 'TENTHLY'
      ) {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_MonthlyBasicPremium';
        }
        if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_MonthlyBasicPremium';
        }
        if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'chd_MonthlyBasicPremium';
        }
        if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'sp_MonthlyBasicPremium';
        }
      }
    }
    if (productType.value === 'GVSP1' || productType.value === 'GVSP2') {
      if (
        billingModeValue.value.toUpperCase() === 'WEEKLY' ||
        billingModeValue.value.toUpperCase() === 'BI-WEEKLY' ||
        billingModeValue.value.toUpperCase() === '28DAY'
      ) {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'sp_WeeklyPremium_';
        } else if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'chd_WeeklyPremium_';
        }
      } else {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_MonthlyPremium_';
        } else if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_MonthlyPremium_';
        } else if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'sp_MonthlyPremium_';
        } else if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'chd_MonthlyPremium_';
        }
      }
    }
    if (
      productType.value === 'GVAP1' ||
      productType.value === 'GVAP2' ||
      productType.value === 'GVAP6' ||
      productType.value === 'GVA1FD' ||
      productType.value === 'GVA2FD'
    ) {
      if (
        billingModeValue.value.toUpperCase() === 'WEEKLY' ||
        billingModeValue.value.toUpperCase() === 'BI-WEEKLY' ||
        billingModeValue.value.toUpperCase() === '28DAY'
      ) {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_WeeklyPremium';
        } else if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_WeeklyPremium';
        } else if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'indSps_WeeklyPremium';
        } else if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'indDep_WeeklyPremium';
        }
      } else if (
        billingModeValue.value.toUpperCase() === 'MONTHLY' ||
        billingModeValue.value.toUpperCase() === 'SEMIMONTHLY' ||
        billingModeValue.value.toUpperCase() === 'NINTHLY' ||
        billingModeValue.value.toUpperCase() === 'TENTHLY'
      ) {
        if (planType.value.toUpperCase() === 'IND') {
          premiumParameter = 'ind_MonthlyPremium';
        }
        if (planType.value.toUpperCase() === 'FAMILY') {
          premiumParameter = 'fam_MonthlyPremium';
        }
        if (planType.value.toUpperCase() === 'INDSPS') {
          premiumParameter = 'indSps_MonthlyPremium';
        } else if (planType.value.toUpperCase() === 'INDCH') {
          premiumParameter = 'indDep_MonthlyPremium';
        }
      }
    }
    return premiumParameter;
  };

  const handleAutoFillPremiumValueGrpProducts = (
    productType: StringUnion,
    packageItem: object | null | undefined,
    billingModeValue: StringUnion,
    planType: StringUnion,
    dateOfBirth?: Date | '',
    insuredSC?: StringUnion,
    spouseSC?: StringUnion,
    packageSourceList?: PackageModel,
    packageSource?: StringUnion,
    plan?: StringUnion
  ) => {
    if (packageItem === undefined || packageItem === null) {
      packageItem = isLoaded(packageSourceList!)
        ? packageSourceList.Data.find((packageItem: object) => packageItem['packageName'] === packageSource!.value)
        : null;
    }
    if (productType.value === 'GVCIP2') {
      let age = 0;
      if (dateOfBirth) {
        age = DateUtility.getAgeFromDob(dateOfBirth);
      } else {
        age = 0;
      }
      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (
        packageItem !== undefined &&
        packageItem !== null &&
        planType.value !== '' &&
        premiumAutoFillParameter !== undefined
      ) {
        let premiumAutoFillParameterValue = '';

        if (billingModeValue.value === 'Monthly' || billingModeValue.value === 'Weekly') {
          if (age >= 18 && age <= 35) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age1';
          } else if (age >= 36 && age <= 50) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age2';
          } else if (age >= 51 && age <= 60) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age3';
          } else if (age >= 61 && age <= 63) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age4';
          } else if (age >= 64) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age5';
          }
          if (age >= 18) {
            if (billingModeValue.value === 'Monthly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeMonthly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            } else if (billingModeValue.value === 'Weekly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeWeekly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            }
          } else {
            dispatch(CIActions.changeCalculatedPremium('0'));
            dispatch(CIActions.changePremium('0'));
            dispatch(changeWeekly('0', 'critical illness'));
            dispatch(changeMonthly('0', 'critical illness'));
          }
        }
      }
    }
    if (productType.value === 'GVCIP1') {
      let age = 0;
      if (dateOfBirth) {
        age = DateUtility.getAgeFromDob(dateOfBirth);
      } else {
        age = 0;
      }
      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (
        packageItem !== undefined &&
        packageItem !== null &&
        planType.value !== '' &&
        premiumAutoFillParameter !== undefined
      ) {
        let premiumAutoFillParameterValue = '';
        if (billingModeValue.value === 'Monthly' || billingModeValue.value === 'Weekly') {
          if (age >= 18 && age <= 35) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age1';
          } else if (age >= 36 && age <= 49) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age2';
          } else if (age >= 50 && age <= 59) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age3';
          } else if (age >= 60 && age <= 64) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age4';
          } else if (age >= 65 && age <= 69) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age5';
          } else if (age >= 70) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age6';
          }
          if (age >= 18) {
            if (billingModeValue.value === 'Monthly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeMonthly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            } else if (billingModeValue.value === 'Weekly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeWeekly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            }
          } else {
            dispatch(CIActions.changeCalculatedPremium('0'));
            dispatch(CIActions.changePremium('0'));
            dispatch(changeWeekly('0', 'critical illness'));
            dispatch(changeMonthly('0', 'critical illness'));
          }
        }
      }
    }
    if (productType.value === 'GVCIFX') {
      let age = 0;
      if (dateOfBirth) {
        age = DateUtility.getAgeFromDob(dateOfBirth);
      } else {
        age = 0;
      }
      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (
        packageItem !== undefined &&
        packageItem !== null &&
        planType.value !== '' &&
        premiumAutoFillParameter !== undefined
      ) {
        let premiumAutoFillParameterValue = '';
        if (billingModeValue.value === 'Monthly' || billingModeValue.value === 'Weekly') {
          if (age >= 18 && age <= 24) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age1';
          } else if (age >= 25 && age <= 29) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age2';
          } else if (age >= 30 && age <= 34) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age3';
          } else if (age >= 35 && age <= 39) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age4';
          } else if (age >= 40 && age <= 44) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age5';
          } else if (age >= 45 && age <= 49) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age6';
          } else if (age >= 50 && age <= 54) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age7';
          } else if (age >= 55 && age <= 59) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age8';
          } else if (age >= 60 && age <= 64) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age9';
          } else if (age >= 65 && age <= 69) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age10';
          } else if (age >= 70 && age <= 74) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age11';
          } else if (age >= 75 && age <= 79) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age12';
          } else if (age >= 80) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age13';
          }

          if (age >= 18) {
            if (billingModeValue.value === 'Monthly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeMonthly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            } else if (billingModeValue.value === 'Weekly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeWeekly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            }
          } else {
            dispatch(CIActions.changeCalculatedPremium('0'));
            dispatch(CIActions.changePremium('0'));
            dispatch(changeWeekly('0', 'critical illness'));
            dispatch(changeMonthly('0', 'critical illness'));
          }
        }
      }
    }
    if (productType.value === 'GVCIP4') {
      let age = 0;
      if (dateOfBirth) {
        age = DateUtility.getAgeFromDob(dateOfBirth);
      } else {
        age = 0;
      }

      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      let premiumAgeBandParameterValue = getAgeBandParameterGVCIP4(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (
        packageItem !== undefined &&
        packageItem !== null &&
        planType.value !== '' &&
        premiumAgeBandParameterValue !== undefined
      ) {
        if (billingModeValue.value !== '') {
          let premiumAutoFillParameterValue = '';
          for (let i = 1; i <= 18; i++) {
            let ageBandAge: string = packageItem[premiumAgeBandParameterValue + 'Age' + i];
            if (ageBandAge?.includes('-')) {
              let minAge = ageBandAge.split('-')[0];
              let maxAge = ageBandAge.split('-')[1];
              if (age >= Number(minAge) && age <= Number(maxAge)) {
                premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age' + i;
                break;
              } else if (age <= Number(minAge)) {
                break;
              }
            } else if (ageBandAge?.includes('+')) {
              let minEqualtoAge = ageBandAge.split('+')[0];
              let maxEqualtoAge = ageBandAge.split('-')[1];
              if (age >= Number(minEqualtoAge)) {
                premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age' + i;
                break;
              }
            }
          }

          if (age >= 18 && (planType.value === 'IND' || planType.value === 'FAMILY')) {
            if (billingModeValue.value === 'Monthly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeMonthly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            } else if (billingModeValue.value === 'Weekly') {
              dispatch(CIActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(CIActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeWeekly(packageItem![premiumAutoFillParameterValue], 'critical illness'));
            }
          } else {
            dispatch(CIActions.changeCalculatedPremium('0'));
            dispatch(CIActions.changePremium('0'));
            dispatch(changeWeekly('0', 'critical illness'));
            dispatch(changeMonthly('0', 'critical illness'));
          }
        }
      }
    }
    if (productType.value === 'GVSP1' || productType.value === 'GVSP2') {
      let age = 0;
      if (dateOfBirth) {
        age = DateUtility.getAgeFromDob(dateOfBirth);
      } else {
        age = 0;
      }

      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (packageItem !== undefined && packageItem !== null && planType.value !== '') {
        let premiumAutoFillParameterValue = '';
        if (billingModeValue.value === 'Monthly' || billingModeValue.value === 'Weekly') {
          if (age >= 18 && age <= 35) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age1';
          } else if (age >= 36 && age <= 49) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age2';
          } else if (age >= 50 && age <= 59) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age3';
          } else if (age >= 60 && age <= 64) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age4';
          } else if (age >= 65 && age <= 69) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age5';
          } else if (age >= 70) {
            premiumAutoFillParameterValue = premiumAutoFillParameter + 'Age6';
          }
          if (age >= 18) {
            if (billingModeValue.value === 'Monthly') {
              dispatch(SActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(SActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeMonthly(packageItem![premiumAutoFillParameterValue], 'hospital indemnity (shop)'));
            } else if (billingModeValue.value === 'Weekly') {
              dispatch(SActions.changeCalculatedPremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(SActions.changePremium(packageItem![premiumAutoFillParameterValue]));
              dispatch(changeWeekly(packageItem![premiumAutoFillParameterValue], 'hospital indemnity (shop)'));
            }
          } else {
            dispatch(SActions.changeCalculatedPremium('0'));
            dispatch(SActions.changePremium('0'));
            dispatch(changeWeekly('0', 'hospital indemnity (shop)'));
            dispatch(changeMonthly('0', 'hospital indemnity (shop)'));
          }
        }
      }
    }
    if (productType.value === 'GVCP2' || productType.value === 'GVCP3') {
      let premiumAutoFillParameter = buildPremiumParameter(
        productType,
        billingModeValue,
        planType,
        insuredSC!,
        spouseSC!
      );
      if (
        packageItem !== undefined &&
        packageItem !== null &&
        planType.value !== '' &&
        premiumAutoFillParameter !== ''
      ) {
        if ((planType.value === 'IND' || planType.value === 'FAMILY') && packageItem!['coverageTiers'] !== '2') {
          if (billingModeValue.value === 'Monthly') {
            dispatch(CActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(CActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'cancer'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(CActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(CActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'cancer'));
          }
        } else if (packageItem!['coverageTiers'] === '2') {
          if (billingModeValue.value === 'Monthly') {
            dispatch(CActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(CActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'cancer'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(CActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(CActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'cancer'));
          }
        } else {
          dispatch(CActions.changeCalculatedPremium('0'));
          dispatch(CActions.changePremium('0'));
          dispatch(changeWeekly('0', 'cancer'));
          dispatch(changeMonthly('0', 'cancer'));
        }
      }
    }
    if (
      plan?.value === 'GVAP1' ||
      plan?.value === 'GVAP2' ||
      plan?.value === 'GVAP6' ||
      plan?.value === 'GVA1FD' ||
      plan?.value === 'GVA2FD'
    ) {
      let premiumAutoFillParameter = buildPremiumParameter(plan, billingModeValue, planType, insuredSC!, spouseSC!);
      if (packageItem !== undefined && packageItem !== null && planType.value !== '') {
        if (plan?.value === 'GVAP1' || plan?.value === 'GVAP2') {
          if (billingModeValue.value === 'Monthly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'accident'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'accident'));
          }
        } else if (
          plan?.value === 'GVAP6' &&
          (packageItem['coverageTier'] === '2' || packageItem['coverageTier'] === 'E') &&
          (planType.value === 'IND' || planType.value === 'FAMILY')
        ) {
          if (billingModeValue.value === 'Monthly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'accident'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'accident'));
          }
        } else if (
          plan?.value === 'GVAP6' &&
          (packageItem['coverageTier'] === '4' || packageItem['coverageTier'] === 'G')
        ) {
          if (billingModeValue.value === 'Monthly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'accident'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'accident'));
          }
        } else if ((plan?.value === 'GVA1FD' || plan?.value === 'GVA2FD') && planType.value !== 'IND') {
          if (billingModeValue.value === 'Monthly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeMonthly(packageItem![premiumAutoFillParameter], 'accident'));
          }
          if (billingModeValue.value === 'Weekly') {
            dispatch(AActions.changeCalculatedPremium(packageItem![premiumAutoFillParameter]));
            dispatch(AActions.changePremium(packageItem![premiumAutoFillParameter]));
            dispatch(changeWeekly(packageItem![premiumAutoFillParameter], 'accident'));
          }
        } else {
          dispatch(AActions.changeCalculatedPremium('0'));
          dispatch(AActions.changePremium('0'));
          dispatch(changeWeekly('0', 'accident'));
          dispatch(changeMonthly('0', 'accident'));
        }
      }
    }
  };
  return handleAutoFillPremiumValueGrpProducts;
};

export default useBuildPremiumParameterAutoFill;
